import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

const CustomerOrdersList = (props) => {
    return (
            props.orders.map((post)=>{

                let ItemList = '';
                post.ITEMS_DET.map((post2)=>{
                    ItemList += post2.QTY+' '+post2.PROD+', ';
                })

                if(ItemList!='')
                    ItemList = ItemList.substring(0, ItemList.length-2);
                
                let url = (post.STATUS2=='D' || post.STATUS2=='C')?'orderdetails':'ordertrack';

                return (
                    <li key={post.ID}>
                        <span className="for-status">
                            <Link className={`badge square chip-${post.STATUS_CSS}2 ht-16 font-size-9 font-weg-500 text-upper ltsp`} to={`/${url}/${post.ID}`}>{post.STATUS}</Link>
                        </span>
                        <Link to={`/${url}/${post.ID}`}>
                            <div className="sumup pt-1 pb-1">
                                <h5 className="font-weg-500 mb-0">{post.DATE2} | Order ID {post.ID} </h5>
                                <span className="text-slgrey font-size-12 mb-05 mr-1">{post.ITEMS_COUNT} item{post.ITEMS_COUNT>1?'s':''}</span>
                                <p className="font-size-11 font-weg-400 mt-05 mb-05 new-color" style={{'height':'28px', 'overflow':'hidden', 'color':'#727272 !important'}}>{ItemList}</p>
                                <div className="stateline">
                                    <span className="font-size-14 font-weg-600 mr-1">₹ {post.TOTAL}</span>
                                </div>
                            </div>
                        </Link>
                    </li>
                )
            })
        
    );
}

class CustomerOrders extends React.Component {
    constructor(props) {
        //console.log(props);
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true,
            CustomerOrders: [],
            OrdersExist: 'N',
            CUSTOMER_DET: ''
        };
    }

    fetchCustomerOrders(mode,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/customerorders_api.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            let customer_orders = result.orders;
            if(customer_orders=='' || customer_orders==undefined)
                customer_orders = '';

            let OrdersExist = 'Y';
            if(customer_orders=='')
                OrdersExist = 'N';

            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
                            
            that.setState({ LOADING:false, CustomerOrders:customer_orders, OrdersExist:OrdersExist, CUSTOMER_DET:CUSTOMER_DET });
        });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }

        let customer = '';

        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        this.fetchCustomerOrders('ORDERS',customer);
    }

    render() { 

        let logged = 'N';
        if(localStorage.getItem('userData'))
            logged = 'Y';

        if (logged=='N')
        {
            if(localStorage.getItem('cartData'))
                return (<Redirect to={'/cart'}/>)
            else
                return (<Redirect to={'/home'}/>)
        }
        
        let Verified = '';
        if(localStorage.getItem('Verified') !== null && localStorage.getItem('Verified')!=='{}')
        {
            if(localStorage.getItem('userData'))
                Verified = localStorage.getItem('Verified');
        }
        else
            Verified = 'N';

        if(Verified=='N')
        {
            return (<Redirect to={'/verifyMobile'}/>);
        }
        
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/profile';
        let AppHeaderTitle = 'Orders';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="delivery-location cart-item-review">
                        { this.state.OrdersExist=='Y' &&
                            <ul className="listview link-listview bg-white">
                                {this.state.CustomerOrders && <CustomerOrdersList orders={this.state.CustomerOrders} /> }
                            </ul>
                        }
                        {this.state.OrdersExist=='N' && 
                            <div className="section pt-6" style={{textAlign: 'center'}}>
                                <img src="/assets/img/no-orders.png" alt="no-orders" className="form-image imaged w200" />
                            </div>
                        }    
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
  
export default CustomerOrders;


// WEBPACK FOOTER //
// ./src/components/CustomerOrders.js